/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { Component } from 'react';
import { confirmWrapper } from 'src/components/Dialog';
import withRouter from '../../hooks/withRouter';
import API from '../../network';

import {
  AssessmentData,
  CandidateAssessmentsProps,
  CandidateAssessmentsState,
  CandidateAssessmentsViewRendererProps,
} from './types';

import ViewRenderer from './views';

class CandidateAssessments extends Component<CandidateAssessmentsProps, CandidateAssessmentsState> {
  constructor(props: CandidateAssessmentsProps) {
    super(props);

    this.state = {
      loading: false,
      assessmentData: null,
      appliedJobs: [],
      assessmentFetching: false,
    };
  }

  componentDidMount() {
    this.fetchAppliedJobs();
  }

  fetchAppliedJobs = async () => {
    this.setState({
      loading: true,
    });

    try {
      const { router: { params: { candidateId } } } = this.props;
      const response: any = await API
        .getInstance()
        .fetchAppliedJobs(candidateId);
      this.setState({
        appliedJobs: response,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  fetchAssessment = async (jobOrderId: string) => {
    this.setState({ assessmentFetching: true });

    try {
      const { router: { params: { candidateId } } } = this.props;
      const response: AssessmentData = await API.getInstance().fetchAssessment({
        candidateId: candidateId as string,
        jobOrderId: jobOrderId as string,
      });
      this.setState({ assessmentData: response });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({ assessmentFetching: false });
    }
  };

  getProps = (): CandidateAssessmentsViewRendererProps => {
    const {
      loading, assessmentData, appliedJobs, assessmentFetching,
    } = this.state;

    return {
      loading,
      assessmentData,
      appliedJobs,
      fetchAssessment: this.fetchAssessment,
      assessmentFetching,
    };
  };

  render() {
    const viewProps: CandidateAssessmentsViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

export default withRouter(CandidateAssessments);
